<div class="select-container" [ngClass]="{ readonly: readOnly }">
    <select
        class="basic-input"
        [id]="inputId"
        (change)="onValueChange()"
        (blur)="markAsTouched()"
        [formControl]="inputControl"
        [compareWith]="compareWithId"
        [ngClass]="{ 'invalid-control': !isValid && touched, 'selected-value': value || value === 0 }"
    >
        <option *ngIf="placeholder" class="placeholder" [ngValue]="null" disabled selected>{{ placeholder | translate }}</option>
        <option *ngFor="let value of config.choices" [ngValue]="value.value">{{ value.label | translate }}</option>
    </select>
</div>
<div class="errors">
    <ng-content></ng-content>
</div>
